import { filterZonesBySectionId, renderRootZones } from "@react/entry";

(function main() {
  renderRootZones();

  window.addEventListener(
    "shopify:section:load",
    (e: CustomEvent<{ sectionId: string | null }>) => {
      if (e?.detail?.sectionId) {
        renderRootZones(filterZonesBySectionId(e.detail.sectionId));
      }
    }
  );
})();
